module.exports = __webpack_public_path__ + "img/price-2.e179d36b.jpg";